import React from 'react'
import accountCircleIcon from '../../assets/icons/account_circle.png'

const AccountCircleIcon = ({ size = 24, style = {} }) => {
  return (
    <img 
      src={accountCircleIcon} 
      alt="Account Circle" 
      width={size} 
      height={size}
      style={{ 
        display: 'inline-block',
        verticalAlign: 'middle',
        ...style 
      }}
    />
  )
}

export default AccountCircleIcon
